/* eslint-disable @typescript-eslint/no-empty-function */
import { ReactElement, useState, createContext } from 'react';
import Form from '../Forms/Forms';
import './RoiCalculator.scss';
import Results from '../Results/Results';
import { RoiCalculatortProps } from '../../lib/type';

// Defining a type for selectedOption context element

interface outputInterface {
  minSavingsBySelfServicedQueriesPerYear: number;
  maxSavingsBySelfServicedQueriesPerYear: number;
  reduceTheTicketsRaisedMin: number;
  reduceTheTicketsRaisedMax: number;
  improveProductivityMin: number;
  improveProductivityMax: number;
  hrTotalSavingsMin: number;
  hrTotalSavingsMax: number;
}

export const layoutContext = createContext({
  output: {
    minSavingsBySelfServicedQueriesPerYear: 0,
    maxSavingsBySelfServicedQueriesPerYear: 0,
    reduceTheTicketsRaisedMin: 0,
    reduceTheTicketsRaisedMax: 0,
    improveProductivityMin: 0,
    improveProductivityMax: 0,
    hrTotalSavingsMin: 0,
    hrTotalSavingsMax: 0,
  },
  setOutput: (output: outputInterface) => {},
});

const RoiCalculator = ({
  configuration,
  jsondata,
}: RoiCalculatortProps): ReactElement => {
  const [output, setOutput] = useState({
    minSavingsBySelfServicedQueriesPerYear: 0,
    maxSavingsBySelfServicedQueriesPerYear: 0,
    reduceTheTicketsRaisedMin: 0,
    reduceTheTicketsRaisedMax: 0,
    improveProductivityMin: 0,
    improveProductivityMax: 0,
    hrTotalSavingsMin: 0,
    hrTotalSavingsMax: 0,
  });

  return (
    <layoutContext.Provider value={{ output, setOutput }}>
      <div className="roi-calculator widget-styles">
        <Form contents={configuration.forms} jsondata={jsondata} />
        <Results contents={configuration.results} />
      </div>
    </layoutContext.Provider>
  );
};

export default RoiCalculator;
